import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {  displayLog, getFileName } from "../common/common";
import DataTable from "../../DRM/components/DataTable";
import { useDispatch, useSelector } from "react-redux";
import { setActiveFiles } from "../../../redux/actions/DRM_files.action";
import { setLoading } from "../../../redux/actions/DRM_user.action";
import CircularProgress from '@mui/material/CircularProgress';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Chip from "@mui/material/Chip";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import Tooltip from "@mui/material/Tooltip";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { axios_tenant } from "../../../../axios";
import CustomDialog from "../components/CustomDialog";
import AuditResultCard from "../components/AuditResultCard";

const CustomNoRowsOverlay = () => {
		return (
			// <div style={{ textAlign: "center" }}>
			<Box sx={{
				display: 'flex', justifyContent: 'center',
				alignItems: 'center', margin: 2,
				fontSize: "20px"
			}}
			>
				There are no items to show
			</Box>
			// </div>
		)
	}

const ActiveFiles = () => {
	const [dialogOpen, setDialogOpen] = useState(false);
	const [dialogProps, setDialogProps] = useState({});
	const [resultLoading, setResultLoading] = useState(false);
	
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const inputRef = useRef(null);
	
	const loading = useSelector((state) => state.userStore.loading);
	
	const activeFiles = useSelector((state) => state.fileStore.activeFiles);
	
	const [reUploadLoading, setReUploadLoading] = useState(false);
	
	const [everyMinuteLoading, setEveryMinuteLoading] = useState(false);
	
	const [uploadPending, setUploadPending] = useState(false);

	const [showResultDialogueBox, setShowResultDialogueBox] = useState(false);
	const [total_added, setTotal_added] = useState(0);
	const [total_duplicate, setTotal_duplicate] = useState(0);
	const [total_ignored, setTotal_ignored] = useState(0);
	const [deleted_duplicate, setDeleted_duplicate] = useState(0);
	const [total_new_errors, setTotal_new_errors] = useState(0);
	const [total_added_tm, setTotal_added_tm] = useState(0);
	const [total_duplicate_tm, setTotal_duplicate_tm] = useState(0);
	const [total_ignored_tm, setTotal_ignored_tm] = useState(0);
	const [deleted_duplicate_tm, setDeleted_duplicate_tm] = useState(0);
	const [total_new_errors_tm, setTotal_new_errors_tm] = useState(0);

useEffect(() => {
	const fetchData = async () => {
		dispatch(setLoading(true));
		getActiveFiles();
	};

	fetchData();
	const interval = setInterval(() => {
		refresh();
		if (!uploadPending) {
			clearInterval(interval);
		}
	}, 5000)

	if (!uploadPending) {
		clearInterval(interval);
	}
	return () => clearInterval(interval)

}, [uploadPending]);

	const getActiveFiles = async () => {
		let response = await axios_tenant.get("/drm/getActiveFilesUploaded").then(res => res.data);
		const updatedFilesArray = response.data.activeFilesUploaded.map(item => {
			if (item.file_name === 'PairPA') {
				// If file_name is 'PairPA', change it to 'PAIRPA'
				return { ...item, file_name: 'PAIRPA' };
			} else {
				// Keep all other fields the same
				return item;
			}
		});

		if (response?.success && response.data.activeFilesUploaded) {
			dispatch(setActiveFiles(updatedFilesArray));
			dispatch(setLoading(false));
		}
		if (updatedFilesArray?.some((obj) => obj.status == "Pending")) {
			setUploadPending(true);
		} else {
			setUploadPending(false);
		}
	};

	const handleClick = () => {
		inputRef.current.click();
	};
	const allFiles = ["WorkingStmtPA", "OpenDocketPA", "IndiaMattersPA", "ClosedDocketPA", "BibliographicPA", "PAIRPA", "ClosedDocketTM", "BibliographicTM"];
    const cpiFiles = ["CPI_BibliographyTM", "CPI_Create_ActionTM", "CPI_Last_ActionTM","User Name"];
	const InproTech_FILES = ['TREXO-DRM-BIBLIOGRAPHICPA', 'TREXO-DRM-OPENDOCKETPA', 'TREXO-DRMINDIAMATTERSPA', 'TREXO-WORKINGSTMTPA','TREXO-DRM-BIBLIOGRAPHICTM'];
	const handleFileChange = (event, failedFileName) => {
		const fileObj = event.target?.files[0];
		if (!fileObj) {
			setReUploadLoading(false);
			return;
		}
		// only re-upload the same file 
		if (!fileObj.name.includes(failedFileName)) {
			displayLog("Please select the same file to re-upload.", "error");
			setReUploadLoading(false);
			return;
		}
		reUploadFile([fileObj]);

		event.target.value = null;
	};

	const reUploadFile = async (files) => {
		setReUploadLoading(true);
		let duplicateFiles = new Set();
		for (let file of files) {
			const fileName = getFileName(file.name).split(".")[0];
			if (fileName === "notFound") {
				setReUploadLoading(false);
				displayLog(file.name + " is not supported.", "error");
				return;
			}
			else if (duplicateFiles.has(fileName)) {
				setReUploadLoading(false);
				displayLog(file.name + " is a duplicate and cannot be uploaded again.", "error");
				return;
			} else {
				duplicateFiles.add(fileName);
			}
		}

		
		let cnfrm = true;

		if (cnfrm) {
			for (let file of files) {
				let formData = new FormData();

				formData.append("file", file);
				const updatedFileName = getFileName(file.name);
				await axios_tenant.post(`/drm/uploadFile?fileName=${updatedFileName}`, formData).then((res) => res.data);


				dispatch(setLoading(false));

				setReUploadLoading(false)
			}
			navigate("/drm/file-upload/files");
		}
		else {
			globalThis.location.reload(false);
		}

	};
	const checkMissingFilesCheck = (pending, content) => {
		return new Promise((resolve, reject) => {
			setDialogProps({
				heading: "Invalid File Combination",
				text: content,
				button1Text: 'Cancel',
				onButton1Click: () => resolve(false),
			});
			setDialogOpen(true);
		});
	};
	const checkMissingFiles = (pending, content) => {
		return new Promise((resolve, reject) => {
			setDialogProps({
				heading: "Missing Files",
				text: content,
				button1Text: 'Run Anyway',
				button2Text: 'Cancel',
				onButton1Click: () => resolve(true),
				onButton2Click: () => resolve(false),
			});
			setDialogOpen(true);
		});
	};

	const cancelUploadDialog = () => {
		return new Promise((resolve, reject) => {
			setDialogProps({
				heading: "Cancel Audit",
				text: "Do you want to cancel Audit and delete uploaded files?",
				button1Text: 'Cancel Audit',
				button2Text: 'Go Back',
				onButton1Click: () => resolve(true),
				onButton2Click: () => resolve(false),
			});
			setDialogOpen(true);
		});
	};

    const normalizeFileName = (name) => name.split(".")[0].toUpperCase();

    const getMissingFiles = ({
        pending,
        activeFileSet,
        hasCpi,
        hasFip,
        hasInproTech,
        missingFipFiles,
        missingCpiFiles,
        missingInproTechFiles,
    }) => {
        if (pending) return [];

        if (activeFileSet.has("PAIRPA") && activeFileSet.has("90DAYOUTPUT")) {
            return [];
        }

        if (hasCpi) return missingCpiFiles;

        if (hasFip) return missingFipFiles;

        if (hasInproTech) return missingInproTechFiles;

        return [];
    };

    // Mixed categories always stop the run; the dialog is informational only.
    const validateSelectedCategory = async (pending, hasCpi, hasFip, hasInproTech) => {
        if (pending) return true;

        const selectedFiles = [hasCpi, hasFip, hasInproTech].filter(Boolean).length;

        if (selectedFiles < 2) {
            return true;
        }

        await checkMissingFilesCheck(
            pending,
            "Only one file can be uploaded at a time. Please upload either FIP, CPI, or InproTech."
        );

        return false;
    };

    const confirmRun = async (pending, missingFiles) => {
        if (pending) {
            return await checkMissingFiles(true, "File uploading is in progress.");
        }

        if (missingFiles.length > 0) {
            return await checkMissingFiles(
                false,
                "Following Files are Missing: " + missingFiles.join(", ")
            );
        }

        return true;
    };

    const updateAuditSummary = (data) => {
        if (data.trademark) {
            setTotal_added_tm(data.trademark.total_added);
            setTotal_duplicate_tm(data.trademark.total_duplicate);
            setTotal_ignored_tm(data.trademark.total_ignored);
            setDeleted_duplicate_tm(data.trademark.deleted_duplicates);
            setTotal_new_errors_tm(
                data.trademark.total_added -
                data.trademark.deleted_duplicates -
                data.trademark.total_ignored
            );
        }

        if (data.patent) {
            setTotal_added(data.patent.total_added);
            setTotal_duplicate(data.patent.total_duplicate);
            setTotal_ignored(data.patent.total_ignored);
            setDeleted_duplicate(data.patent.deleted_duplicates);
            setTotal_new_errors(
                data.patent.total_added -
                data.patent.deleted_duplicates -
                data.patent.total_ignored
            );
        }
    };

    const runFiles = async () => {
        const pending = activeFiles?.some(file => file.status !== "Pass");

        const activeFileSet = new Set(
            (activeFiles || []).map(file => normalizeFileName(file.file_name))
        );

        const normFipFiles = allFiles.map(normalizeFileName);
        const normCpiFiles = cpiFiles.map(normalizeFileName);
        const normInproTechFiles = InproTech_FILES.map(normalizeFileName);

        const hasCpi = normCpiFiles.some(file => activeFileSet.has(file));
        const hasFip = normFipFiles.some(file => activeFileSet.has(file));
        const hasInproTech = normInproTechFiles.some(file => activeFileSet.has(file));

        const isValidCategory = await validateSelectedCategory(
            pending,
            hasCpi,
            hasFip,
            hasInproTech
        );

        if (!isValidCategory) {
            return;
        }

        const missingFiles = getMissingFiles({
            pending,
            activeFileSet,
            hasCpi,
            hasFip,
            hasInproTech,
            missingFipFiles: normFipFiles.filter(file => !activeFileSet.has(file)),
            missingCpiFiles: normCpiFiles.filter(file => !activeFileSet.has(file)),
            missingInproTechFiles: normInproTechFiles.filter(file => !activeFileSet.has(file)),
        });

        const shouldRun = await confirmRun(pending, missingFiles);

        if (!shouldRun) {
            return;
        }

        setResultLoading(true);

        const response = await axios_tenant.get("/drm/runActiveRules?category=all");

        if (response?.status === 200) {
            updateAuditSummary(response.data);

            setResultLoading(false);
            setShowResultDialogueBox(true);
            dispatch(setActiveFiles([]));
        }
    };

	const cancelFiles = async () => {
		if (activeFiles?.length !== 8) {

			let confirmCancel = await cancelUploadDialog();
			// stopUploadDialogue
			if (!confirmCancel) {
				return;
			}
		}

		let response = await axios_tenant.get("/drm/cancelActiveRules").then((res) => res.data);

		if (response?.success) {
			dispatch(setActiveFiles([]));
			navigate("/drm/audit-result");
		}
	};

	const refresh = async () => {
		setEveryMinuteLoading(true);
		await getActiveFiles();
		setEveryMinuteLoading(false);
	};
	const columns = [
		{
			field: "file_name",
			headerName: "Input File Name",
			width: 150,
			flex: 1,
			name: "Input File Name",
			selector: (row) => row.file_name,
		},
		{
			field: "status",
			headerName: "Status",
			width: 150,
			flex: 0.5,
			name: "Status",
		renderCell: ({ row }) => {
			if (row.status === "Pass") {
				return <Chip label="Pass" color="success" size="small" />;
			}

			if (row.status === "Fail") {
				return <Chip label="Fail" color="error" size="small" />;
			}

			return <CircularProgress color="warning" size={25} />;
		},
		},
		{
			headerName: "Reason of Failure",
			field: "reason_of_failure",
			// cell: (row) => <span title={row.reason_of_failure}>{row.reason_of_failure}</span>,
			selector: (row) => row.reason_of_failure,
			width: 280,
			flex: 1.5,
			sortable: true,
		},
		{
			headerName: "Recommended Step",
			field: "recommended_steps",
			// cell: (row) => <span title={row.recommended_steps}>{row.recommended_steps}</span>,
			selector: (row) => row.recommended_steps,
			// width: "220px",
			width: 220,
			flex: 2.5,
			sortable: true,
		},
		{
			headerName: "Action",
			renderCell: ({ row }) =>
				row.status == "Fail" ? (
					<Box display="flex" justifyContent="flex-end" onClick={handleClick} sx={{ cursor: 'pointer', alignItems: 'center' }} gap={1}>
						{/* <input style={{ display: "none" }} ref={inputRef} type="file" onChange={handleFileChange} accept=".xlsx, .xlsb, .csv" multiple /> */}
						<input style={{ display: "none" }} ref={inputRef} type="file" onChange={
							e => handleFileChange(e, row.file_name)
						} accept=".xlsx, .xlsb, .csv" />
						{reUploadLoading ? <CircularProgress color="warning" size={25} /> : <CloudUploadIcon />}
						<p>Re upload</p>
					</Box>
				) : null,
			right: true,
			flex: 1
		},
	];



	return (
			<Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', mx: 'auto', px: 1 }}>
				<DataTable
					columns={columns}
					data={activeFiles}
					loading={loading}
					showToolbar={false}
					noRowsOverlay={CustomNoRowsOverlay}
					noDataComponent={loading ? "Fetching data... " : "There are no items to show"}
					hideFooter
				/>

				{activeFiles.length ? (
					<Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4, mr: 4 }}>
						<div>
							<Tooltip title="Refresh">
								<Button disabled={everyMinuteLoading} onClick={() => refresh()} startIcon={<RefreshIcon />}>
								</Button>
							</Tooltip>
						</div>
						<div>
							<Button variant="outlined" disabled={resultLoading} sx={{ mx: 1 }} onClick={() => cancelFiles()}>
								Cancel
							</Button>
							<Button variant="contained" disabled={resultLoading || uploadPending} onClick={() => runFiles()}>
								Run
							</Button>
						</div>

					</Box>
				) :
					null
				}
				{resultLoading ? (
					<Box
						sx={{
							position: 'fixed',
							zIndex: 9999,
							top: "0",
							left: "0",
							right: "0",
							bottom: "0",
							backgroundColor: "rgba(0,0,0,0.5)",
						}}
					>
						<CircularProgress sx={{ position: 'absolute', top: "50%", left: "50%" }} />
					</Box>
				) : (
					<Dialog
						open={showResultDialogueBox}
						fullWidth={true}
						onClose={() => setShowResultDialogueBox(false)}
						aria-labelledby="alert-dialog-title"
						aria-describedby="alert-dialog-description"

					>
						<DialogTitle id="alert-dialog-title" sx={{
							display: "flex",
							alignItems: "start",
							gap: "8px",
							marginTop: "10px",
						}}>
							<InfoOutlinedIcon
								sx={{ color: '#008ad5', fontSize: '25px' }}
							/>
							Run all patent and trademark documents and check the final audit results in their respective tabs.
						</DialogTitle>
						<DialogContent

						>
							<DialogContentText >

								<AuditResultCard
									ip={"Patent"}
									totalObservations={total_added}
									totalNewErrors={total_new_errors}
									totalDuplicatesRemoved={deleted_duplicate}
									totalUniqueErrors={total_new_errors - total_duplicate}
									totalIngoredErrors={total_ignored}
									totalCorrectedIdentified={total_duplicate}
								/>
								<br />
								<AuditResultCard
									ip={"Trademark"}
									totalObservations={total_added_tm}
									totalNewErrors={total_new_errors_tm}
									totalDuplicatesRemoved={deleted_duplicate_tm}
									totalUniqueErrors={total_new_errors_tm - total_duplicate_tm}
									totalIngoredErrors={total_ignored_tm}
									totalCorrectedIdentified={total_duplicate_tm}
								/>
								
							</DialogContentText>
						</DialogContent>
						<DialogActions>
							<Button
								variant="contained"
								onClick={() => {
									setShowResultDialogueBox(false)
									navigate("/drm/audit-result");
								}} autoFocus>
								View Results
							</Button>
						</DialogActions>
					</Dialog>
				)}
				<CustomDialog open={dialogOpen} onClose={() => setDialogOpen(false)} {...dialogProps} />
			</Box >
	);
};

export default ActiveFiles;